import { render } from "./CustomDashboard.vue?vue&type=template&id=2882ceb8&scoped=true"
import script from "./CustomDashboard.vue?vue&type=script&lang=js"
export * from "./CustomDashboard.vue?vue&type=script&lang=js"

import "./CustomDashboard.vue?vue&type=style&index=0&id=2882ceb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2882ceb8"],['__file',"src/containers/dashboard/CustomDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2882ceb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2882ceb8', __exports__)) {
    api.reload('2882ceb8', __exports__)
  }
  
  module.hot.accept("./CustomDashboard.vue?vue&type=template&id=2882ceb8&scoped=true", () => {
    api.rerender('2882ceb8', render)
  })

}


export default __exports__